export default {
      id: "avatar-placeholder-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#avatar-placeholder",
      toString: function () {
        return this.url;
      }
    }